import { BrowserHistory, createBrowserHistory } from 'history';

let history: BrowserHistory;

const __get_history__ = () => {
  if (history) return history;
  history = createBrowserHistory({ window });
  return history;
};

export default function useHistory() {
  return __get_history__();
}
